export function snapToQuarterHour(x: number): number {
  return Math.round(x * 4) / 4;
}
